import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useField } from 'formik';
import Select from 'react-select';

import styles from './DropdownInput.module.scss';

const {
  'dropdown-input': dropdownInputClass,
  label: labelClass,
  'has-error': hasErrorClass,
  error: errorClass,
  footnote: footnoteClass
} = styles;

const customSelectStyles = {
  control: provided => ({
    ...provided,
    width: '100%',
    height: '4.5rem',
    border: '0.1rem solid #828892',
    borderRadius: '0.7rem'
  }),
  valueContainer: provided => ({
    ...provided,
    padding: '0.2rem 1.6rem'
  }),
  placeholder: () => ({
    color: '#828892',
    textAlign: 'left',
    fontSize: '1.8rem',
    fontWeight: '300'
  }),
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none'
  }),
  dropdownIndicator: provided => ({
    ...provided,
    padding: '0.8rem 2rem'
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? 'blue' : 'black',
    backgroundColor: state.isSelected ? '#f3f3f3' : 'white',
    padding: '0.7rem 2rem'
  })
};

const DropdownInput = ({
  placeholder = '',
  options = [],
  locked,
  label,
  footnote,
  customClass,
  storyClass,
  customInputClass,
  customLabelClass,
  customFootnoteClass,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;
  const optionsMapped = useMemo(() => {
    return options.map(val => ({ value: val, label: val }));
  }, [options]);

  const dropdownInputClasses = classNames(dropdownInputClass, {
    [customClass]: customClass,
    [hasErrorClass]: meta.touched && meta.error
  });

  return (
    <div className={dropdownInputClasses}>
      <label className={`${labelClass} ${customLabelClass}`} htmlFor={props.id || props.name}>
        {label}
      </label>
      <Select
        {...{ placeholder }}
        styles={customSelectStyles}
        options={optionsMapped}
        name={field.name}
        onChange={({ value }) => setValue(value)}
        defaultInputValue={field.value}
      />
      {meta.touched && meta.error && <div className={errorClass}>{meta.error}</div>}
      {footnote && <div className={`${footnoteClass} ${customFootnoteClass}`}>{footnote}</div>}
    </div>
  );
};

export default DropdownInput;
